
import listArrange from '@/components/temporary/list-arrange'
import divSpan from '@/components/DivSpan';
import listHeaderTemplate from '@/components/list-template/list-header-template';
import Badge from 'vux/src/components/badge/index.vue'

export default {
name: "receivedTp",
data() {
return {
listHeaderTemplateBoard: {},
listArrange: [],
approvalTemplateBoard: {}
}
},
props: ['data'],
created() {
let templateData = this.data;
this.listHeaderTemplateBoard = {
template: listHeaderTemplate.contractQueryV2,
data() {
return {
title: [templateData.docNum,templateData.rowNum],
desc: [templateData.plantName,templateData.storageLocationName,templateData.storageType]
}
}
};
this.listArrange = [
{
icon: "fa fa-file-text-o font-size-mr",
span: 20,
templateBoard: {
template: "<span class=\"black\">{{matName}}</span>",
data() {
return {
matName: templateData.matName
}
},
components: {
divSpan
}
}
},
{
span: 4,
templateBoard: {
template: "<span class=\"arrange_float_right arrange_weight_100\">x{{amount}}<div-span dictCode='unit' :dictItemCode=\"unit\"></div-span></span>",
data() {
return {
amount: templateData.amount,
unit:templateData.unit
}
},
components: {
divSpan
}
}
}
]
},
methods: {},
components: {
listArrange,
divSpan,
listHeaderTemplate
}
}



// WEBPACK FOOTER //
// ./src/components/page-temporary/receivedTp.vue